import { Component, Input } from '@angular/core';
import {
    ICON_REQUIRED,
    ICON_SENSITIVE,
} from '../../../constants/icons.constants';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-summary-field',
    templateUrl: './molecule-summary-field.component.html',
    host: { class: 'd-block' },
    standalone: false,
})
export class MoleculeSummaryFieldComponent {
    @Input() label: string;
    @Input() isRequired: boolean;
    @Input() isSensitive: boolean;
    @Input() isPending: boolean;
    @Input() labelOnly: boolean;
    @Input() cySelector: string;

    readonly ICON_SENSITIVE = ICON_SENSITIVE.icon;
    readonly ICON_REQUIRED = ICON_REQUIRED.icon;
}
